import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

/**
 * Короткое уведомление внизу экрана с действием («Сохранено · Отменить»).
 * Новое уведомление — новый `toast.id`: таймер начинается заново.
 */
export default function BfUndoToast({ toast, onDismiss, duration = 5000 }) {
  const dismissRef = useRef(onDismiss);
  dismissRef.current = onDismiss;

  useEffect(() => {
    if (!toast) return undefined;
    const id = setTimeout(() => dismissRef.current?.(), duration);
    return () => clearTimeout(id);
  }, [toast?.id, duration]);

  if (!toast || typeof document === 'undefined') return null;

  return createPortal(
    <div className="bf-undo-toast" role="status" aria-live="polite">
      <span className="bf-undo-toast__text">{toast.text}</span>
      {toast.actionLabel && toast.onAction && (
        <button
          type="button"
          className="bf-undo-toast__action"
          onClick={() => {
            dismissRef.current?.();
            toast.onAction();
          }}
        >
          {toast.actionLabel}
        </button>
      )}
    </div>,
    document.body
  );
}
